import React from 'react'
import LoginCard from '../../Layouts/LoginCard/LoginCard'

export const Login = () => {
  return (
    <div id='Login'>
      <LoginCard />
    </div>
  )
}